module.exports = __webpack_public_path__ + "static/media/tr.7e9e605d.svg";